import * as React from 'react';
import { cn } from '@noor/lib/cn';
import { Tooltip, TooltipContent, TooltipTrigger } from './tooltip';

export interface TruncatedTextProps extends React.ComponentProps<'span'> {
  /** Full text — rendered ellipsized and shown whole in the tooltip. */
  text: string;
}

/**
 * Single-line ellipsis that always reveals the full text in a tooltip on
 * hover. Use for every truncated value (table cells, drawer rows, dialog
 * titles) so shortened content is never the only copy the user can see.
 */
function TruncatedText({ text, className, ...props }: TruncatedTextProps) {
  if (text.trim() === '') {
    return (
      <span className={cn('min-w-0 truncate', className)} {...props}>
        {text}
      </span>
    );
  }
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className={cn('min-w-0 truncate', className)} {...props}>
          {text}
        </span>
      </TooltipTrigger>
      <TooltipContent className="max-w-xs break-all">{text}</TooltipContent>
    </Tooltip>
  );
}

export { TruncatedText };
